import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { ReporteVisita } from '../Models/ReporteVisita';
import { ReporteViaje } from '../Models/ReporteViaje';
import { ReporteTarea } from '../Models/ReporteTarea';
import { PuntoVisita } from '../Models/PuntoVisita';
import { VisitaIncidencia } from '../Models/VisitaIncidencia';
import { ReporteFacturacion } from '../Models/ReporteFacturacion';
import { Nota } from '../Models/Nota';
import { Visita } from '../Models/Visita';
import { ReporteDevolucion } from '../Models/ReporteDevolucion';

@Injectable()
export class ReporteViajeService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }

  /**
   * Obtine informacion de los viajes para la primera fase del reporte de viaje
   * @param compania Codigo de la compañia
   * @param idUsuario codigo del usuario
   * @param nombrePunto Nombre del punto de visita
   * @param idveiculo codigo de vehiculo (placa)
   * @param fechaInicio fecha inicio
   * @param fechaFin fecha fin
   */
  ObtenerReporteViaje(compania: string, idUsuario: string,
    nombrePunto: string, idveiculo: string, fechaInicio: Date, fechaFin: Date): Observable<ReporteViaje[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reporteviaje/" + compania + '/' + idUsuario + '/' + nombrePunto
        + '/' + idveiculo + '/' + fechaInicio + '/' + fechaFin);


      return this._http.get(url).map((response: Response) => {
        return <ReporteViaje[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene informacion de la visitas para la segunda fase del reporte de viaje
   * @param compania Codigo de la compañia
   * @param idUsuario Codigo del usuario
   * @param idveiculo Codigo del vehiculo (placa)
   * @param idViaje codigo del viaje
   */
  ObtenerReporteVisitas(compania: string, idUsuario: string,
    idveiculo: string, idViaje: string): Observable<ReporteVisita[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reporteVisitas/" + compania + "/" + idUsuario + "/" + idveiculo + "/" + idViaje);

      return this._http.get(url).map((response: Response) => {
        return <ReporteVisita[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

  /**
   *Obtiene infromacion de las tareas para el reporte de viaje, tercera parte
   * @param compania Codigo de la compañia
   * @param idVisita Codigo del punto de visita
   */
  ObtenerReporteTarea(compania: string, idVisita: string): Observable<ReporteTarea[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reporteTarea/" + compania + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <ReporteTarea[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Ovtiene la informacion de kas visita abortadas por el mobile
   * @param compania Codigo de la compañia
   * @param idVisita Codigo del punto de visita
   */
  ObtenerReportePuntoVisitaAbortado(compania: string, idVisita: string): Observable<VisitaIncidencia[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reportePuntoVisitaAbortado/" + compania + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <VisitaIncidencia[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }
  /**
   * Obtiene la informacion para el reporte de facturacion con recpecto al numero documeto
   * @param compania Codigo de la compa;ia
   * @param numeroDocumento Numero de documento 
   */
  ObtenerReporteFacturacion(compania: string, numeroDocumento: string): Observable<ReporteFacturacion[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reportefacturacion/" + compania + '/' + numeroDocumento);


      return this._http.get(url).map((response: Response) => {
        return <ReporteFacturacion[]>response.json();
      });


    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene la informacion para la tabla del reporte Galeria
   * @param compania Codigo de la compañia 
   * @param idVisita Codigo de la visita
   */
  ObtenerReporteGaleria(compania: string, idVisita: string,tipoNota: string): Observable<ReporteTarea[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/reportegaleria/" + compania + '/' + idVisita+ '/' + tipoNota);


      return this._http.get(url).map((response: Response) => {
        return <ReporteTarea[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene las notas (Fotografias) que se obtuvieron de la visita
   * @param compania Codigo de la compañia
   * @param idVisita Codigo de la visita
   */
  ObtenerNotasVisita(compania: string, idVisita: string): Observable<Nota[]> {

    try {

      let url = this._utiles.getURL("reporteviajes/notaVisita/" + compania + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <Nota[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

  
  ObtenerReporteEncabezadoDevolucion(compania: string, numeroDocumento: string, fechaInicio: Date, fechaFin: Date, tipoTarea:string): Observable<ReporteDevolucion[]> {

    try {

      let url = this._utiles.getURL("ReporteViajes/reporteEncabezadoDevolucion/" + compania + '/' +
       numeroDocumento+ '/'+ fechaInicio+'/'+ fechaFin+ '/'+tipoTarea );


      return this._http.get(url).map((response: Response) => {
        return <ReporteDevolucion[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


  ObtenerReporteDetalleEncabezado(compania: string, idVisita: string): Observable<ReporteDevolucion[]> {

    try {

      let url = this._utiles.getURL("ReporteViajes/reporteDetalleDevolucion/" + compania + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <ReporteDevolucion[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

}
